// extracted by mini-css-extract-plugin
export default {"AppWhatWeOffer":"AppWhatWeOffer_AppWhatWeOffer__4dWtM","AppWhatWeOffer__wrap":"AppWhatWeOffer_AppWhatWeOffer__wrap__ZcAno"};